import { setStepName } from '../actions/set-step-name';
import { AngularServices, getAngularService } from '../../core';
import { TroubleshootingStepName } from '../constants';
import { store } from '../../../store/store';
export const commonFlow = {
    [TroubleshootingStepName.Initial]: {
        textItems: [{ text: 'troubleshooting.wizard.refreshVideoDescription' }],
        actions: {
            primary: {
                text: 'troubleshooting.wizard.refreshVideoButton',
                onClick: async () => {
                    const activeProvider = getAngularService(AngularServices.VideoProviderFactory).activeProvider;
                    try {
                        store.dispatch(setStepName(TroubleshootingStepName.VideoIsRefreshing));
                        await activeProvider.initPublisher();
                        store.dispatch(setStepName(TroubleshootingStepName.VideoRefreshed));
                    }
                    catch (e) {
                        store.dispatch(setStepName(TroubleshootingStepName.VideoRefreshed));
                    }
                },
            },
        },
    },
    [TroubleshootingStepName.VideoIsRefreshing]: {
        textItems: [{ text: 'troubleshooting.wizard.refreshVideoPending' }],
    },
    [TroubleshootingStepName.ProblemResolved]: {
        textItems: [{ text: 'troubleshooting.wizard.problemResolved' }],
    },
    [TroubleshootingStepName.NothingHelped]: {
        textItems: [
            { text: 'troubleshooting.wizard.nothingHelpedDescription1' },
            {
                text: 'troubleshooting.wizard.nothingHelpedDescription2{link}',
                link: {
                    text: 'troubleshooting.wizard.nothingHelpedDescription2.link',
                    url: 'https://help.doxy.me/en/articles/3544172-how-to-improve-poor-video-quality',
                },
            },
        ],
    },
};
